/** MUI menu opens below the field (no upward flip). */
const DROPDOWN_ITEM_HEIGHT = 48;
const DROPDOWN_ITEM_PADDING_TOP = 8;

export const codeliveDropdownMenuProps = {
  disablePortal: false,
  anchorOrigin: {
    vertical: 'bottom' as const,
    horizontal: 'left' as const,
  },
  transformOrigin: {
    vertical: 'top' as const,
    horizontal: 'left' as const,
  },
  PaperProps: {
    style: {
      maxHeight: DROPDOWN_ITEM_HEIGHT * 6.5 + DROPDOWN_ITEM_PADDING_TOP,
      zIndex: 2000,
    },
  },
  MenuListProps: {
    dense: true,
  },
};
